// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"NotFoundMessage_ErrorMessage__xROOs"};